export default "<div style=\"text-align:center; padding-top:100px;\">\n    <h1>Page not found</h1>\n</div>\n"